// Loads the legacy jQuery 1.12 UMD bundle for side effects only and
// re-exports the jQuery function from `window.jQuery`.
//
// The legacy file's UMD browser branch sets `window.jQuery` + `window.$`
// itself via `(function(window){ ... }(window))`. Using the namespace
// import (`import * as ...; jQueryModule.default || jQueryModule`)
// risks overwriting the legit jQuery function with the empty
// `[object Module]` namespace when Vite/esbuild does not detect the
// UMD's `module.exports` branch — that produced the
// "Cannot assign to property 'ui' of [object Module]" crash inside
// jquery-ui-1.10.3.js, which uses `jQuery` as a bare global.

import 'jquery'

const jQuery = window.jQuery
window.$ = jQuery

export default jQuery
